/**
 * HeaderAndSectionItemSecondLevel.js
 * Created by calhosh on 2/6/2022.
 */
import React from 'react';
import EllipseControl from '../EllipsesControl/EllipsesControl';
import ValidationControl from '../CanvasForm/Common/ValidationControl';
import {entities} from '../../../util/uiconstants';
import {useDocumentId} from '../../../util/customHooks';

function HeaderAndSectionItemSecondLevel({
	clearComments,
	railData,
	currentSectionId,
	getRailName,
	onClickHandle,
	showValidationsIcon,
	isExpanded
}) {
	const documentId = useDocumentId();

	return (
		<>
			{railData.name && (railData.isCustom || railData.isDisplayed) && (
				<ul key={railData.id} className="canvasFormLeftNavSliderSubList">
					<li
						data-id={railData.id}
						className={`canvasformSubHeader ${currentSectionId === railData.id ? 'activeSection' : ''}`}
					>
						<section className="canvasformSectionWrapper">
							<section
								data-id={railData.id}
								className="canvasformSubHeaderIcon"
								title={railData.customLabel ? getRailName(railData.name, railData.customLabel) : railData.name}
								onClick={onClickHandle}
							/>
							<span data-id={railData.id} className="canvasformSubHeaderText" onClick={onClickHandle}>
								<EllipseControl
									content={railData.customLabel ? getRailName(railData.name, railData.customLabel) : railData.name}
									tooltip={railData.customLabel ? getRailName(railData.name, railData.customLabel) : railData.name}
									displayId={''}
									noOfLines={4}
								/>
							</span>
							{showValidationsIcon &&
								(railData.incompleteCount ?? 0) +
									(railData.unresolvedCount ?? 0) +
									(railData.itFlowValidationCount ?? 0) >
									0 && (
									<span className="section-validationCount">
										<ValidationControl
											documentId={documentId}
											incompleteResponseCount={railData.incompleteCount ?? 0}
											unresolvedCommentCount={railData.unresolvedCount ?? 0}
											hideIcon
											railExpanded={isExpanded}
											darkBg
											clearComments={clearComments}
											entityUId={railData.id}
											entityId={entities.FormSection}
											itFlowValidationCount={railData.itFlowValidationCount ?? 0}
											itFlowFormValidations={railData?.itFlowValidations || []}
										/>
									</span>
								)}
						</section>
					</li>
				</ul>
			)}
		</>
	);
}
export default React.memo(HeaderAndSectionItemSecondLevel);
